import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DispatchSelect from './DispatchSelect';
import { incidentOperations } from '../../redux/incident';
import { resourceOperations } from '../../redux/resource';
import { configOperations } from '../../redux/config';

const useStyles = makeStyles(theme => ({
  header: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(2),
    position: 'relative'
  },
  select: {
    minWidth: '500px'
  },
  closeButton: {
    float: 'right',
    backgroundColor: 'white'
  }
}));

/**
 * The Header div that contains the DispatchSelect and close button.
 */
const DispatchHeader = ({
  currentDispatchID,
  dispatchOptions,
  setCurrentDispatchID,
  getResources
}) => {
  const { header, closeButton, select } = useStyles();
  return (
    <Paper className={header}>
      <DispatchSelect
        className={select}
        dispatchOptions={dispatchOptions}
        currentDispatchID={currentDispatchID}
        setCurrentDispatchID={setCurrentDispatchID}
        getResources={getResources}
      />
      <Link
        to={
          window.location.search
            ? `/dispatchmap/${window.location.search}`
            : '/dispatchmap'
        }
      >
        <Button variant="contained" className={closeButton}>
          Fullscreen Map
        </Button>
      </Link>
    </Paper>
  );
};

DispatchHeader.propTypes = {
  /**
   * The ID of the current dispatch.
   */
  currentDispatchID: PropTypes.string,
  /**
   * The array dispatches used to populate the select.
   */
  dispatchOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ),
  /**
   * The handler for when the select onChange.
   */
  setCurrentDispatchID: PropTypes.func
};

DispatchHeader.defaultProps = {
  currentDispatchID: 'Select Dispatch Center',
  dispatchOptions: [
    { id: 'Select Dispatch Center', name: 'Loading dispatches...' }
  ],
  setCurrentDispatchID: () => {
    console.log('Loading dispatches...');
  }
};

const mapStateToProps = state => ({
  map: state.map
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...incidentOperations,
      ...resourceOperations,
      ...configOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DispatchHeader)
);



// WEBPACK FOOTER //
// ./src/components/dispatches/DispatchHeader.js